// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HPUD","content":"styles_content__3fNFf","tableWrap":"styles_tableWrap__1C8LJ"};